
import subscriptionPlansPopover    from '../../shared/subscription-plans-popover';
import groupLicensePopover         from '../../shared/group-license-popover';


let getStartedWithProBtn, planDisplay, getPricingEstimateBtn;

const pricingPage = {

  init: function () {
    getStartedWithProBtn = document.querySelector('.get-started-with-pro');
    getPricingEstimateBtn = document.querySelector('.pricing-estimate-button');
    planDisplay = document.querySelector('.selected-plan-display');

    /*
    ==================================================
      WIRE BEHAVIORS
    ==================================================
    */

    if (getStartedWithProBtn) {  
      getStartedWithProBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleGetStartedWithProButtonClick();
      });
    }

    if (planDisplay) {
      this.handlePreselectedSubscriptionHover();
    }

    if (getPricingEstimateBtn) {
      this.handlePricingEstimateBtnClick();
    }
  },


  /*
  ==================================================
    EVENT HANDLERS
  ==================================================
  */

  handleGetStartedWithProButtonClick() {
    const planId = this.getSelectedPlanId();
    if (!planId) return;

    const planName = this.getSelectedPlanName();
    if (!planName) return;
  
    const url = this.buildSignUpUrl({ source: 'pricing', planId: planId, planName: planName });
    this.redirectTo(url);
  },

  handlePreselectedSubscriptionHover () {
    this.showSubscriptionPlansPopover(true);
  },

  handlePricingEstimateBtnClick () {
    this.showGroupLicensePopover(true);
  },

  /*
  ==================================================
    LOCAL UTILS
  ==================================================
  */

  buildSignUpUrl({ source, planId, planName }) {
    const params = new URLSearchParams({ source, planId: planId, planName: planName });
    return `/sign-up?${params.toString()}`;
  },

  getSelectedPlanId(selector = '.dynamic-plans-pricing') {
    const element = document.querySelector(selector);
    return element?.dataset.planId || null;
  },

  getSelectedPlanName(selector = '.dynamic-plans-pricing') {
    const element = document.querySelector(selector);
    return element?.dataset.planName?.toLowerCase() || null;
  },

  redirectTo(url) {
    window.location.href = url;
  },

  showSubscriptionPlansPopover() {
    subscriptionPlansPopover.render({
      selector: '.selected-plan-display',
      subscriptionPlansData: JSON.parse(document.getElementById('subscription-plans').dataset.plans),
    });
  },

  showGroupLicensePopover() {
    groupLicensePopover.render({
      selector: '.pricing-estimate-button',
    });
  }
};

export default pricingPage;
